import React from "react";
import nextId from "react-id-generator";
import { BlockMachine } from "../Context/Context";
import "./transaction-page.style.scss";
import TransactionMoreInfo from "./TransactionMoreInfo";
import TransactionOverview from "./TransactionOverview";
export default function TransactionPage() {
  const context = React.useContext(BlockMachine);
  const { loggedIn } = context;
  const [selectedTab, setSelectedTab] = React.useState(headers[0]);
  return (
    <div className="transaction-page-main">
      <div className="t-p-m-header">
        <h3>Transactions / Details</h3>
      </div>
      <div className="t-p-m-tab">
        <div className="t-p-m-tab-header">
          {headers.map((obj) => (
            <h4
              onClick={() => setSelectedTab(obj)}
              className={obj.id === selectedTab.id ? "selected-tab" : ""}
              key={obj.keyId}
            >
              {obj.name}
            </h4>
          ))}
        </div>
        <div className="t-p-m-tab-body">
          {selectedTab.id === "more" ? (
            <TransactionMoreInfo />
          ) : (
            <TransactionOverview />
          )}
        </div>
      </div>
    </div>
  );
}
const headers = [
  { keyId: nextId(), name: "Overview", id: "overview" },
  { keyId: nextId(), name: "More Info", id: "more" },
];
